import React, { createContext, useContext, useState, useEffect } from 'react';

const CredentialsContext = createContext({
  apiKey: null,
  email: null,
  setCredentials: () => {},
  clearCredentials: () => {},
  hasValidCredentials: () => false
});

export const CredentialsProvider = ({ children }) => {
  // Keep credentials only in memory - no persistence
  const [apiKey, setApiKey] = useState(null);
  const [email, setEmail] = useState(null);

  const setCredentials = (newApiKey, newEmail) => {
    if (!newApiKey || !newEmail) {
      console.error('Invalid credentials provided');
      return;
    }

    // Only store in memory, not in sessionStorage for security
    setApiKey(newApiKey);
    setEmail(newEmail);
  };

  const clearCredentials = () => {
    setApiKey(null);
    setEmail(null);
  };

  const hasValidCredentials = () => {
    return Boolean(apiKey && email);
  };

  const value = {
    apiKey,
    email,
    setCredentials,
    clearCredentials,
    hasValidCredentials
  };

  return (
    <CredentialsContext.Provider value={value}>
      {children}
    </CredentialsContext.Provider>
  );
};

export const useCredentials = () => {
  const context = useContext(CredentialsContext);

  if (!context) {
    throw new Error('useCredentials must be used within a CredentialsProvider');
  }

  return context;
};

export default CredentialsContext;
